/**
 * @file src/views/VID/views/hooks/clearVidDataShared.ts
 * @exports clearVidDataState
 * @summary Shared vID data-clearing routine used by both manager and React hooks.
 */

import { clearIndexedDB } from "src/shame/shame-atoms";

import { VID_SESSION_STORAGE_KEY } from "src/views/VID/vidStorageKey";

type ClearVidDataStateProps = {
	resetSessionData: () => void;
	resetSessionFiles: () => void;
	setHideSensitiveData: (value: boolean) => void;
};

export const clearVidDataState = ({
	resetSessionData,
	resetSessionFiles,
	setHideSensitiveData,
}: ClearVidDataStateProps) => {
	// Clear IndexedDB first; atom values still need explicit in-memory resets.
	clearIndexedDB();
	resetSessionData();

	if (typeof window !== "undefined") {
		try {
			window.sessionStorage.removeItem(VID_SESSION_STORAGE_KEY);
		} catch {
			// ignore
		}
	}

	resetSessionFiles();
	setHideSensitiveData(true);
};
